module.exports = __webpack_public_path__ + "media/University.3f1f0f37.mp3";